import { IGlobalReducerState } from "Store/Base/interface/IGlobalReducerState";

const getSelectedEditRowKeys = (state: IGlobalReducerState) => state.listagemArquivos.selectedEditRowKeys;

export { getSelectedEditRowKeys };
